const notifications = store => {
  store.notify = (title, message, type = null) => {
    store._vm.$notify({
      title,
      text: message,
      type
    })
  }
}

export default notifications
